// extracted by mini-css-extract-plugin
module.exports = {"cursor":"styles_cursor__2SNdl","blink":"styles_blink__3iP6b"};